import _ from "lodash"

import {
	CancelForListFragment,
	CancelType,
} from "@/main/gql/__generated__/graphql"

export type EditingRow = {
	cancelType: CancelType
	originPrice: string // inputを空にもできるようにするためstring。空文字か数字しか入らないはずではある。現状先頭0入ってしまう。tableのorigin_priceはnumber型
	invoicePrice: number
	visitCounts: number // 請求額プレビューの計算に使う。編集では変わらない
	phoneNumber: string // 数字しか入力できないが、0始まりOK
	name: string
	couponMasterId?: string
}

export type EditingRereservationRow = {
	phoneNumber: string // 数字しか入力できないが、0始まりOK
}

export type Tab =
	| "INVOICE_NOT_SENT"
	| "NOT_SUBJECT"
	| "INVOICE_SENT"
	| "PAID"
	| "ENCOURAGING_RERESERVATION_NOT_SCHEDULED"
	| "ENCOURAGING_RERESERVATION_SCHEDULED"
	| "RERESERVED"

export const confirmUpdatePaymentStatusButtonMessage = (
	cancels: readonly CancelForListFragment[],
	checkedCancelMap: Record<number, CancelForListFragment>,
	currentTab: "INVOICE_NOT_SENT" | "NOT_SUBJECT"
) => {
	let tabName = "非請求タブ"
	if (currentTab === "NOT_SUBJECT") {
		tabName = "未請求タブ"
	}

	let message =
		_.size(checkedCancelMap) +
		"件選択されています。\n" +
		tabName +
		"に移しますか?\n\n" +
		"来店予定日 請求先\n"

	cancels.forEach((cancel) => {
		if (cancel.id in checkedCancelMap) {
			message += cancel.dateVisit + " " + cancel.name + "\n"
		}
	})

	return message
}
